import { useGetStationDisplayName } from "@/entities/station";
import {
    TvvBesteldeRoute,
    TvvStandaardRoute,
    useVraagTvvRouteStopAan,
    useVraagTvvStopAlleRoutesAan,
    type RouteForTitel,
} from "@/entities/tvv";
import { ConfirmDialog } from "@/shared/components/ui";

type StopRouteDialogProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    dossierId: string;
    routes: TvvBesteldeRoute[];
};

export function StopRouteDialog({ open, onOpenChange, dossierId, routes }: StopRouteDialogProps) {
    const { mutate: stopRoute, isPending: stopRoutePending, error: stopRouteError } = useVraagTvvRouteStopAan();
    const { mutate: stopAlleRoutes, isPending: stopAlleRoutesPending, error: stopAlleRoutesError } = useVraagTvvStopAlleRoutesAan();
    const getStationDisplayName = useGetStationDisplayName();

    const isPending = stopRoutePending || stopAlleRoutesPending;
    const error = stopRouteError || stopAlleRoutesError;
    const isSingleRoute = routes.length === 1;
    const route = routes[0];

    const handleConfirm = () => {
        if (isSingleRoute) {
            stopRoute({ dossierId, tvvId: route.id }, { onSuccess: () => onOpenChange(false) });
        } else {
            stopAlleRoutes({ dossierId }, { onSuccess: () => onOpenChange(false) });
        }
    };

    let title: string, description: string, confirmLabel: string;
    if (isSingleRoute && route) {
        const routeForTitel: RouteForTitel = {
            organisatie: route.organisatie,
            stationCodes: route.stationCodes,
            routeSoort: route.routeSoort,
            voertuigSoort: route.voertuigSoort,
            isOvRoute: route.isOvRoute,
            totaleRijtijd: route.totaleRijtijd,
            busFrequentiePerUur: route.busFrequentiePerUur,
            ovLijnNummer: route.ovLijnNummer,
        };
        const routeTitel = TvvStandaardRoute.formatBeginEindStation(routeForTitel, getStationDisplayName);
        title = `Stopverzoek route`;
        description = `Weet je zeker dat je ${routeTitel} wilt stoppen?`;
        confirmLabel = `Route stoppen`;
    } else {
        title = "Stopverzoek alle routes";
        description = `Weet je zeker dat je alle routes wilt stoppen?`;
        confirmLabel = `Alle routes stoppen`;
    }

    return (
        <ConfirmDialog
            isOpen={open}
            onCancel={() => onOpenChange(false)}
            onConfirm={handleConfirm}
            title={title}
            confirmLabel={confirmLabel}
            cancelLabel="Annuleren"
            destructive
            isPending={isPending}
            error={error}
        >
            {description}
        </ConfirmDialog>
    );
}
